import editorConfig from '~config/editorConfig';
import { addObjRefId, triggerStateChangedRequest } from '~core';
import { convertTextboxesToSpellCheck, checkSpelling } from '~core/spellcheck';

export const onCloneObjects = (event) => {
  event.preventDefault();

  const selection = window.canvas.getActiveObject();

  if (!selection) {
    return;
  }

  if (selection.type === 'activeSelection') {
    let hasMagicFrame = false;
    selection.forEachObject((obj) => {
      if (obj.type === 'MagicFrame') {
        hasMagicFrame = true;
      }
    });
    if (hasMagicFrame) {
      alert('Operazione attualmente non disponibile');
      return;
    }
  }

  if (selection.type === 'MagicFrame') {
    const newFrame = selection.clone({ withOffsetX: 100, withOffsetY: 100 });

    window.canvas.add(newFrame);

    newFrame.on('frame:init', function (cloned) {
      addObjRefId(cloned);

      // TODO: fix properly, atm it does not preserve editingImg props on clone
      if (selection.editingImg) {
        newFrame.scalePersonToWidth(selection.editingImg.width);
      }

      newFrame.set({
        top: selection.top + 100,
        left: selection.left + 100,
      });

      window.canvas.renderAll();
      triggerStateChangedRequest();
    });
    return;
  }

  selection.clone(async (cloned) => {
    window.canvas.discardActiveObject();
    cloned.set({
      top: cloned.top + 20,
      evented: true,
    });
    if (cloned.type === 'activeSelection') {
      // active selection needs a reference to the window.canvas.
      cloned.canvas = window.canvas;
      cloned.forEachObject((obj) => {
        window.canvas.add(obj);
      });
      cloned.setCoords();
    } else {
      window.canvas.add(cloned);
    }
    addObjRefId(cloned);
    window.canvas.setActiveObject(cloned);
    window.canvas.requestRenderAll();

    // Convert any cloned textboxes to SpellCheckTextbox and check spelling
    await convertTextboxesToSpellCheck(window.canvas);
    try {
      await checkSpelling(window.canvas);
    } catch (error) {
      console.error('Error checking spelling after cloning:', error);
    }
  }, editorConfig.additionalJsonProperties);
};
